import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
const ratingBreakdown = [{
  stars: 5,
  label: '5 Star',
  percentage: 90
}, {
  stars: 4,
  label: '4 Star',
  percentage: 7
}, {
  stars: 3,
  label: '3 Star',
  percentage: 2
}, {
  stars: 2,
  label: '2 Star',
  percentage: 0
}, {
  stars: 1,
  label: '1 Star',
  percentage: 1
}];
const featureRatings = [{
  name: 'Price',
  rating: 5.0
}, {
  name: 'Effectiveness',
  rating: 5.0
}, {
  name: 'Comfort',
  rating: 5.0
}, {
  name: 'Quality',
  rating: 4.8
}];
function StarRating({
  rating,
  size = 'sm'
}: {
  rating: number;
  size?: 'sm' | 'md';
}) {
  const fullStars = Math.floor(rating);
  const starSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  return <div className="flex" data-id="element-390">
      {[...Array(5)].map((_, i) => <Star key={i} className={`${starSize} ${i < fullStars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-391" />)}
    </div>;
}
export function SidebarCTA() {
  return <div className="hidden lg:block w-80 flex-shrink-0" data-id="element-392">
      <div className="sticky top-4 space-y-4" data-id="element-393">
        {/* Recommended Section */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-394">
          <h3 className="text-center font-bold text-gray-900 text-lg py-4 border-b border-gray-100" data-id="element-395">
            Recommended
          </h3>

          {/* Product Image - 1:1 ratio */}
          <div className="bg-gradient-to-b from-[#21afa1]/10 to-white p-4" data-id="element-396">
            <div className="aspect-square w-full overflow-hidden rounded-lg" data-id="element-397">
              <img src="https://cdn.magicpatterns.com/uploads/nGwAxHcNKpi2Sk9GY8YVmY/ChatGPT_Image_5_Φεβ_2026,_03_33_50_μ.μ..png" alt="Nymera Lymphatic Drainage Softgels" className="w-full h-full object-cover" data-id="element-398" />
            </div>
          </div>

          {/* CTA Button */}
          <div className="p-4" data-id="element-399">
            <a href="https://trynymera.com/products/nymera-lymphatic-drainage-softgels" className="block w-full bg-[#0d5d55] hover:bg-[#0a4a44] text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all hover:shadow-lg text-center text-sm" data-id="element-400">
              GET 30% OFF Nymera Lymphatic Drainage Softgels Now!
            </a>
          </div>
        </div>

        {/* Customer Reviews Section */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden p-5" data-id="element-401">
          <h3 className="text-center font-bold text-gray-900 text-lg mb-4" data-id="element-402">
            Customer Reviews
          </h3>

          {/* Overall Rating */}
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-403">
            <StarRating rating={4.8} size="md" data-id="element-404" />
            <span className="font-bold text-gray-900" data-id="element-405">4.8 out of 5</span>
          </div>

          <p className="text-center text-gray-500 text-sm mb-4" data-id="element-406">
            3,791 customer ratings
          </p>

          {/* Rating Breakdown */}
          <div className="space-y-2 mb-6" data-id="element-407">
            {ratingBreakdown.map(item => <div key={item.stars} className="flex items-center gap-3 text-sm" data-id="element-408">
                <span className="w-12 text-[#0d5d55] font-medium" data-id="element-409">
                  {item.label}
                </span>
                <div className="flex-1 h-5 bg-gray-100 rounded overflow-hidden" data-id="element-410">
                  <div className="h-full bg-yellow-400 rounded" style={{
                width: `${item.percentage}%`
              }} data-id="element-411" />
                </div>
                <span className="w-10 text-right text-yellow-600 font-medium" data-id="element-412">
                  {item.percentage}%
                </span>
              </div>)}
          </div>

          {/* By Feature */}
          <div className="border-t border-gray-100 pt-4" data-id="element-413">
            <h4 className="font-bold text-gray-900 mb-3" data-id="element-414">By Feature</h4>
            <div className="space-y-2" data-id="element-415">
              {featureRatings.map(feature => <div key={feature.name} className="flex items-center justify-between text-sm" data-id="element-416">
                  <span className="text-gray-600" data-id="element-417">{feature.name}</span>
                  <div className="flex items-center gap-2" data-id="element-418">
                    <StarRating rating={feature.rating} data-id="element-419" />
                    <span className="text-gray-700 font-medium w-8" data-id="element-420">
                      {feature.rating}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Trust Badge */}
          <div className="flex items-center justify-center gap-2 mt-5 pt-4 border-t border-gray-100 text-sm text-gray-600" data-id="element-421">
            <ShieldCheck className="w-5 h-5 text-[#21afa1]" data-id="element-422" />
            <span className="font-medium" data-id="element-423">60-Day Money Back Guarantee</span>
          </div>
        </div>
      </div>
    </div>;
}